export default __webpack_public_path__ + "static/media/1.201ee322.pdf";